import React from 'react';

import { Navigate } from 'react-router-dom';

import { useAuthStore } from '../store/useAuthStore.ts';

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * A wrapper component that redirects authenticated users to the dashboard
 * Primarily used for routes like login that should only be accessible to non-authenticated users
 */
const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectTo = '/dashboard',
}) => {
  const { isAuthenticated } = useAuthStore();

  // If user is authenticated, redirect to dashboard
  if (isAuthenticated) {
    // Set flag to indicate this is a redirect from login page
    sessionStorage.setItem('loginRedirect', 'true');
    return <Navigate to={redirectTo} />;
  }
  
  return children;
};

export default PublicRoute;
